









import { Component, Vue } from 'vue-property-decorator'
import { faBook } from '@fortawesome/free-solid-svg-icons'
import { faTwitter, faGithub } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

@Component({
  components: {
    FontAwesomeIcon
  }
})
export default class FooterNav extends Vue {
  private twitter = faTwitter
  private github = faGithub
  private book = faBook
  private copyRightText = '© ' + new Date().getFullYear() + ' あやせさん'
}
